module.exports = __webpack_public_path__ + "media/core_static/40px-106a7abc.png";